export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["OPERATOR"] = "OPERATOR";
    UserRole["READONLY"] = "READONLY";
})(UserRole || (UserRole = {}));
// build a runtime set from the enum values
const KNOWN_ROLES = new Set(Object.values(UserRole));
export function normalizeRolesFromClaim(raw) {
    if (!raw) {
        // No claim at all -> READONLY
        return [UserRole.READONLY];
    }
    const arr = Array.isArray(raw) ? raw : [raw];
    const matched = arr
        .filter((v) => typeof v === "string")
        .map((r) => r.trim().toUpperCase())
        .filter((r) => KNOWN_ROLES.has(r));
    if (matched.length === 0) {
        return [UserRole.READONLY];
    }
    return Array.from(new Set(matched));
}
